import { render, staticRenderFns } from "./orderYearlyChartWidget.vue?vue&type=template&id=353ba3c6&"
import script from "./orderYearlyChartWidget.vue?vue&type=script&lang=js&"
export * from "./orderYearlyChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports